<div class="dialog">
  <div mat-dialog-title
       class="dialog-title">
    <h1>{{ 'global.dialogs.barcode.title' | translate }}</h1>
  </div>
  <div mat-dialog-content
       class="dialog-content">
    <div>
      <ngx-barcode6 [bc-value]="data.barcode"
                    [bc-display-value]="true"
                    [bc-width]="1"
                    [bc-height]="20"
                    [bc-format]="'CODE128'"
                    [bc-element-type]="'svg'">
      </ngx-barcode6>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions
       class="dialog-actions">
    <button mat-stroked-button
            (click)="close()">
      {{ 'global.buttons.close' | translate }}
    </button>
  </div>
</div>